import "@hotwired/turbo-rails";
import * as ActiveStorage from '@rails/activestorage'
import "@/javascript/channels";
import "virtual:windi.css";

ActiveStorage.start();

import "@/view_components";
import "@/stylesheets/application.scss";